import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './Notifications.scss';

/**
 * @class Notifications
 * @classdesc Global Notifications Component
 * @property {Object} state
 * @property {(Object | null)} dismissTimeout
 */
export default class Notifications extends Component {
  static propTypes = {
    hideToast: PropTypes.func.isRequired,
    notification: PropTypes.shape({
      state: PropTypes.string,
      title: PropTypes.string,
      message: PropTypes.string,
      dismissble: PropTypes.bool,
    }).isRequired,
    showing: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    const { showing } = this.props;
    this.state = {
      showing,
    };
    this.dismissTimeout = null;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.showing !== prevState.showing) return { showing: nextProps.showing };
    return null;
  }

  /**
   * Handles click on Notification component, dismisses notifications if dismissible
   * @return {(Function|null)}
   */
  handleDismiss = () => {
    const { hideToast, notification } = this.props;
    const { dismissible } = notification;

    if (dismissible) return hideToast();
    return null;
  }

  /**
   * Initialize method to setTimeout for dismissAfter value -- return null if dismissAfter false
   * @return {(Function|null)}
   */
  initTimeout = () => {
    const { hideToast, notification } = this.props;

    this.dismissTimeout = notification.dismissAfter
      ? setTimeout(() => hideToast(), notification.dismissAfter)
      : null;
  }

  render() {
    const { notification, showing } = this.props;
    const success = notification.state === 'SUCCESS';
    /* If showing, check if we need to setTimeout if dismissAfter is true */
    if (showing) this.initTimeout();
    /* If showing is not true, return null. */
    if (!showing) return null;
    return (
      <div
        onClick={this.handleDismiss}
        className={classNames(
          styles.notificationsContainer,
          { [styles.notificationsContainerError]: !success }
        )}
      >
        <div className={styles.notifications}>
          <div className={success ? styles.successBlock : styles.errorBlock} />
          <div className={styles.notificationsContent}>
            <p className={styles.notifyTitle}>{notification.title}</p>
            <p className={styles.notifyMessage}>{notification.message}</p>
          </div>
        </div>
      </div>
    );
  }
}
